import { useTranslation } from 'react-i18next';
import myImage02 from '../image/02.jpg';
import myImage03 from '../image/03.jpg';
export default function Contact() {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-20 sm:py-32 bg-gradient-to-br from-[#faf6f0] to-[#fdf9f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl mb-10 sm:mb-12">
          <div className="w-full h-[220px] sm:h-[350px] lg:h-[500px]">
            <img
              src = {myImage02}
              alt="Showroom"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="text-center space-y-6 sm:space-y-8 mb-12 sm:mb-16">
          <p className="text-3xl sm:text-4xl lg:text-5xl leading-relaxed">
            <span className="text-[#3a2a1a] font-bold">{t('contact_title_bold')}</span>
          </p>
        </div>

        {/* 社交媒体二维码 */}
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-3 gap-4 sm:gap-10">
            {/* 小红书 */}
            <div className="flex flex-col items-center group">
              <div className="w-24 h-24 sm:w-44 sm:h-44 bg-white rounded-xl sm:rounded-2xl shadow-lg border border-[#e8ddd0] flex items-center justify-center mb-3 group-hover:shadow-xl transition-shadow overflow-hidden">
                <img
                  src ={myImage03}
                  alt={t('contact_xhs_label')}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex items-center gap-1 sm:gap-2 mb-1">
                <div className="w-4 h-4 sm:w-6 sm:h-6 flex items-center justify-center">
                  <i className="ri-book-mark-line text-rose-400 text-sm sm:text-lg"></i>
                </div>
                <span className="font-semibold text-[#3a2a1a] text-xs sm:text-base">{t('contact_xhs_label')}</span>
              </div>
              <p className="text-xs text-[#7a6050] text-center">{t('contact_xhs_desc')}</p>
            </div>

            {/* 抖音 */}
            <div className="flex flex-col items-center group">
              <div className="w-24 h-24 sm:w-44 sm:h-44 bg-white rounded-xl sm:rounded-2xl shadow-lg border border-[#e8ddd0] flex items-center justify-center mb-3 group-hover:shadow-xl transition-shadow overflow-hidden">
                <img
                    src ={myImage03}
                  alt={t('contact_dy_label')}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex items-center gap-1 sm:gap-2 mb-1">
                <div className="w-4 h-4 sm:w-6 sm:h-6 flex items-center justify-center">
                  <i className="ri-tiktok-line text-[#3a2a1a] text-sm sm:text-lg"></i>
                </div>
                <span className="font-semibold text-[#3a2a1a] text-xs sm:text-base">{t('contact_dy_label')}</span>
              </div>
              <p className="text-xs text-[#7a6050] text-center">{t('contact_dy_desc')}</p>
            </div>

            {/* 微信 */}
            <div className="flex flex-col items-center group">
              <div className="w-24 h-24 sm:w-44 sm:h-44 bg-white rounded-xl sm:rounded-2xl shadow-lg border border-[#e8ddd0] flex items-center justify-center mb-3 group-hover:shadow-xl transition-shadow overflow-hidden">
                <img
                    src ={myImage03}
                    alt={t('contact_wx_label')}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex items-center gap-1 sm:gap-2 mb-1">
                <div className="w-4 h-4 sm:w-6 sm:h-6 flex items-center justify-center">
                  <i className="ri-wechat-line text-emerald-500 text-sm sm:text-lg"></i>
                </div>
                <span className="font-semibold text-[#3a2a1a] text-xs sm:text-base">{t('contact_wx_label')}</span>
              </div>
              <p className="text-xs text-[#7a6050] text-center">{t('contact_wx_desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}